import React, { useState, useEffect } from 'react';
import { useTransition, animated } from '@react-spring/web';
import { Typography } from '@mui/material';

const AnimatedHeadline = (props) => {
  const phrases = [
    "organize your garage",
    "clear out the clutter",
    "maximize your space",
    "showcase your products"
  ];

  const [index, setIndex] = useState(0);

  // Update index every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % phrases.length);
    }, 3000); // Change the phrase every 3 seconds
    return () => clearInterval(interval);
  }, [phrases.length]);

  // Transition for animating text
  const transitions = useTransition(phrases[index], {
    from: { opacity: 0, transform: 'translate3d(0, -20px, 0)' },
    enter: { opacity: 1, transform: 'translate3d(0, 0, 0)' },
    leave: { opacity: 0, transform: 'translate3d(0, 20px, 0)' },
    config: { tension: 200, friction: 20 },
  });

  return (
    <div style={{ position: 'relative', height: '60px' }}>
      {transitions((style, item) => (
        <animated.div style={{ ...style, position: 'absolute', width: '100%' }}>
          <Typography
            fontSize={props.responsiveSize}
            lineHeight={.9}
            fontWeight={600}
            color="primary"
            component="h1"
            variant="h1"
            fontFamily="Readex Pro Variable"
          >
            {item}
          </Typography>
        </animated.div>
      ))}
    </div>
  );
};

export default AnimatedHeadline;
